import React from "react";
export default function Testimonials() {
    const reviews = [
        {
            name: "Rahul Sharma",
            review: "Amazing quality products and fast delivery. Highly recommended!",
            image: "https://i.pravatar.cc/100?img=1"
        },
        {
            name: "Priya Patel",
            review: "Customer service was very helpful. I love the shopping experience.",
            image: "https://i.pravatar.cc/100?img=2"
        },
        {
            name: "Arjun Kumar",
            review: "Great prices and beautiful product collection. Will shop again!",
            image: "https://i.pravatar.cc/100?img=3"
        }
    ];
    return (
        <section className="testimonial-section">
            <div className="testimonial-title">
                <h2>What Our Customers Say</h2>
                <div className="title-line"></div>
            </div>
            <div className="testimonial-container">
                {reviews.map((item, index) => (
                    <div className="testimonial-card" key={index}>
                        <img src={item.image} alt={item.name} />
                        <p className="testimonial-review">"{item.review}"</p>
                        <h4>{item.name}</h4>
                        <div className="stars">⭐⭐⭐⭐⭐</div>
                    </div>
                ))}
            </div>
        </section>
    );
}